import { useEffect, useRef } from "react";

export const useIsInitialRender = () => {
  const useIsInitialRenderRef = useRef(true);
  useEffect(() => {
    useIsInitialRenderRef.current = false;
  }, []);
  return useIsInitialRenderRef.current;
};